import React from 'react';
import { Link } from 'react-router-dom';
import './Solutions.scss';

const Solutions = () => {
  const solutions = [
    {
      name: 'IT & Technology',
      path: '/solutions/it-technology',
      description: 'AI-powered solutions for IT and technology companies'
    },
    {
      name: 'Healthcare',
      path: '/solutions/healthcare',
      description: 'Innovative healthcare solutions powered by AI'
    },
    {
      name: 'Manufacturing',
      path: '/solutions/manufacturing',
      description: 'Streamline manufacturing processes with AI'
    },
    {
      name: 'Financial Services',
      path: '/solutions/financial-services',
      description: 'Transform financial services with AI automation'
    },
    {
      name: 'Retail',
      path: '/solutions/retail',
      description: 'Enhance retail operations with AI solutions'
    },
    {
      name: 'Education',
      path: '/solutions/education',
      description: 'Revolutionize education with AI technology'
    }
  ];

  return (
    <div className="solutions-page">
      <div className="container">
        <h1 className="solutions-page__title">Our Solutions</h1>
        <p className="solutions-page__subtitle">
          Discover how our AI-powered solutions can transform your business
        </p>
        <div className="solutions-page__grid">
          {solutions.map((solution) => (
            <Link
              key={solution.path}
              to={solution.path}
              className="solutions-page__card"
            >
              <h3 className="solutions-page__card-title">{solution.name}</h3>
              <p className="solutions-page__card-description">{solution.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Solutions; 